module.exports = __webpack_public_path__ + "img/yjey-1.332360a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yjey-1.jpg
// module id = RKP4
// module chunks = 0